module.exports = __webpack_public_path__ + "media/images/themes/mandy/14-b98c547f0eb761c0bd85f2f73114da98.png";